import Projects from './components/projects/projectsArticle'
import './App.css';

const App = () => {
  return (
    <Projects />
  )
}

export default App;
